/**
 * Bag Bar — Stitch theme: mobile nav + cart count refresh
 */
(function () {
  const drawer = document.querySelector('[data-tay-nav-drawer]');
  const toggleOpen = document.querySelector('[data-tay-menu-open]');
  const toggleClose = document.querySelector('[data-tay-menu-close]');
  const backdrop = document.querySelector('[data-tay-nav-backdrop]');

  function setOpen(open) {
    if (!drawer) return;
    drawer.dataset.open = open ? 'true' : 'false';
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('bbs-nav-open', open);
    if (toggleOpen instanceof HTMLButtonElement) {
      toggleOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  toggleOpen?.addEventListener('click', () => setOpen(true));
  toggleClose?.addEventListener('click', () => setOpen(false));
  backdrop?.addEventListener('click', () => setOpen(false));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer?.dataset.open === 'true') {
      setOpen(false);
    }
  });

  async function refreshCartCount() {
    const els = document.querySelectorAll('[data-cart-count]');
    if (!els.length) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = String(cart.item_count ?? 0);
      els.forEach((el) => {
        el.textContent = count;
        el.classList.toggle('is-empty', Number(cart.item_count ?? 0) === 0);
      });
    } catch {
      /* ignore */
    }
  }

  document.addEventListener('tay:cart-updated', refreshCartCount);

  /**
   * @param {ParentNode | null | undefined} root
   */
  function bindGiftDisclosure(root) {
    if (window.BbsCartGift && typeof window.BbsCartGift.bindGiftUi === 'function') {
      window.BbsCartGift.bindGiftUi(root);
      return;
    }
    if (!root) return;
    const check = root.querySelector('[data-bbs-gift-check]');
    const wrap = root.querySelector('[data-bbs-gift-note-wrap]');
    if (!(check instanceof HTMLInputElement) || !(wrap instanceof HTMLElement)) return;
    const sync = () => {
      wrap.hidden = !check.checked;
    };
    check.addEventListener('change', sync);
    sync();
  }

  const cartForm = document.querySelector('[data-bbs-cart-form]');
  if (cartForm instanceof HTMLFormElement) {
    bindGiftDisclosure(cartForm);

    cartForm.addEventListener('submit', async (e) => {
      const submitter = e.submitter instanceof HTMLButtonElement ? e.submitter : null;
      const wantsCheckout = submitter?.name === 'checkout';
      const updates = {};
      cartForm.querySelectorAll('[data-line-key]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        const key = input.dataset.lineKey;
        if (!key) return;
        const qty = Math.max(0, Math.floor(Number(input.value) || 0));
        updates[key] = qty;
      });

      e.preventDefault();
      const gift = window.BbsCartGift
        ? window.BbsCartGift.readGiftCartPayload(cartForm)
        : { gift: '', gift_note: '', note: '' };
      const attributes = { gift: gift.gift, gift_note: gift.gift_note };
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, attributes, note: gift.note }),
        });
      } catch {
        /* reload / continue so the cart page reflects server state */
      }
      if (wantsCheckout) {
        window.location.assign('/checkout');
        return;
      }
      window.location.assign(cartForm.getAttribute('action') || '/cart');
    });

    cartForm.querySelectorAll('[data-bbs-remove-design]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (!(btn instanceof HTMLButtonElement)) return;
        const keys = String(btn.dataset.lineKeys || '')
          .split('|')
          .map((k) => k.trim())
          .filter(Boolean);
        if (!keys.length) return;
        btn.disabled = true;
        /** @type {Record<string, number>} */
        const updates = {};
        keys.forEach((key) => {
          updates[key] = 0;
        });
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates }),
          });
        } catch {
          /* reload anyway */
        }
        window.location.assign(cartForm.getAttribute('action') || '/cart');
      });
    });
  }
})();
